export const add = (a, b) => a + b;
export const sum = (array, transform = (props) => props) => {
  return array.map(transform).reduce(add, 0);
};
export const average = (array, transform = (props) => props) => {
  return sum(array, transform) / array.length;
};
export const min = (array, transform = (props) => props) => {
  const transformedArray = array.map(transform);
  return Math.min(...transformedArray);
};
export const max = (array, transform = (props) => props) => {
  const transformedArray = array.map(transform);
  return Math.max(...transformedArray);
};
